import {connect} from 'react-redux';
import {findSection, updateSectionValue} from '../ducks/reportSections';
import {updatePreferences} from '../actionCreators/preferences';
import CustomiseFloorPlanSection from './CustomiseFloorPlanSection';
import actionCreators from '../actionCreators';


const mapStateToProps = (state) => {
  const reportType = state.reportType.value;
  const section = findSection(state.reportSections, reportType, 'FLOOR_PLAN');
  return {
    section,
    reportType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendEvent: (section, title) => {
      dispatch(actionCreators.sendEditTitleAnalyticsEvent(section, title));
    },
    updateSectionValue: (value, dataKeyPath, reportType) => {
      dispatch(updateSectionValue({value, reportType, key: 'FLOOR_PLAN', dataKeyPath: `sectionData.${dataKeyPath}`}));
    },
    updatePreferences: (preferences, reportType) => {
      dispatch(updatePreferences(preferences, reportType));
    }
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    updateSectionValue: (value, dataKeyPath) => {
      dispatchProps.updateSectionValue(value, dataKeyPath, stateProps.reportType);
      dispatchProps.sendEvent(stateProps.section, value);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CustomiseFloorPlanSection);